/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import CartesianStackgroup from './cartesian.stack';
import {pluck, BLANKSTRING, visibleStr, parseTooltext} from '../../lib/lib';

var createGroup = function (groupName, parentContainer, manager) {
  var animationManager = manager.getFromEnv('animationManager');
  return animationManager.setAnimation({
    el: 'group',
    attr: {name: groupName},
    container: parentContainer,
    component: manager,
    label: 'group'
  });
};
/**
 * class for marimekko group manager
 */
class MarimekkoStackgroup extends CartesianStackgroup {
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'group';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'marimekkoStackgroup';
  }

  /**
   * Function to return the stackConf of groupmanager
   * @return {Object} configurations
   */
  getstackConf () {
    return this.config.stackConf;
  }
  /**
   * function to calculate plot position, max and min of manager in case a of stacked dataset
   */
  _setStackPosition () {
    super._setStackPosition();
    var manager = this,
      config = manager.config,
      stackPercentValues,
      stackConf = config.stackConf || (config.stackConf = []),
      stackSumValue = config.stackValues,
      catObj,
      categories = manager.getFromEnv('categories')[0].category,
      numberFormatter = manager.getFromEnv('number-formatter'),
      positionStackConfig,
      sum = 0,
      sumValue = 0,
      sumPercent = 0,
      k,
      len,
      x,
      xAxis = manager.getFromEnv('xAxis'),
      range = xAxis.getVisibleConfig(),
      xMin = range.minValue,
      xMax = range.maxValue,
      diff = xMax - xMin,
      tempX = xMin;
    for (k = 0, len = stackSumValue.length; k < len; k++) {
      sumValue += (stackSumValue[k] && stackSumValue[k].positive) || 0;
    }
    config.totalSumValue = sumValue;
    for (k = 0; k < categories.length; k++) {
      catObj = categories[k];
      if (catObj.widthpercent) {
        sum += numberFormatter.getCleanValue(catObj.widthpercent);
      }
    }
    if (sum === 100) {
      config.setUserWidth = 1;
    }
    stackPercentValues = manager.getStackSumPercent();
    for (k = 0, len = stackSumValue.length; k < len; k++) {
      if (!(positionStackConfig = stackConf[k])) {
        positionStackConfig = stackConf[k] = {};
      }
      sumPercent = (sumPercent + stackPercentValues[k] / 100);
      x = ((stackPercentValues[k] / 100) * diff) / 2 + tempX;
      tempX = sumPercent * diff + xMin;
      positionStackConfig.x = x;
      xAxis.updateTicksValues(k, {x: x});
    }
  }
  /**
   * This function returns an array containing the percent values of individual stack
   * @return {Array} conatains the total value of each stack in percentage
   */
  getStackSumPercent () {
    var manager = this,
      config = manager.config,
      stackSumValue = config.stackValues,
      totalSumValue = config.totalSumValue,
      i,
      numberFormatter = manager.getFromEnv('number-formatter'),
      categories = manager.getFromEnv('categories')[0].category,
      setUserWidth = config.setUserWidth,
      arr = [];
    for (i = 0; i < stackSumValue.length; i++) {
      if (setUserWidth) {
        arr[i] = numberFormatter.getCleanValue(categories[i].widthpercent);
      } else {
        arr[i] = ((stackSumValue[i] && stackSumValue[i].positive) || 0) / totalSumValue * 100;
      }
    }
    return arr;
  }

  /**
   * Draw function of group manager
   */
  draw () {
    super.draw();
    this.drawLabel();
  }

  /**
   * Function to create container for labels
   */
  createContainer () {
    super.createContainer();
    var manager = this,
      parent = manager.getLinkedParent();

    !manager.getContainer('commonLabelContainer') && manager.addContainer('commonLabelContainer',
      createGroup('manager-commonLabelContainer', parent.getChildContainer('vcanvasLabelGroup'), manager));
  }

  /**
   * This function draws the cumulative percentage labels appearing at bottom right of the stack
   */
  drawLabel () {
    var manager = this,
      config = manager.config,
      smartLabel = manager.getFromEnv('smartLabel'),
      animationManager = manager.getFromEnv('animationManager'),
      stackPercentValues = manager.getStackSumPercent(),
      chartAttr = manager.getFromEnv('chart-attrib'),
      jsonData,
      datasets = manager.getChildren('dataset'),
      dataset,
      data,
      stackConf = config.stackConf,
      xPos,
      yPos,
      index,
      commonLabelContainer = manager.getContainer('commonLabelContainer'),
      numberFormatter = manager.getFromEnv('number-formatter'),
      percentValue = 0,
      formatedPercentValue,
      attr,
      chartConfig = manager.getFromEnv('chartConfig'),
      canvasBottom = chartConfig.canvasBottom,
      xAxis = manager.getFromEnv('xAxis'),
      inCanvasStyle = manager.getFromEnv('style'),
      style = chartConfig.dataLabelStyle,
      length = stackPercentValues.length,
      bBoxObj,
      labelEle,
      labelEleCheck,
      sumValues = config.stackValues,
      borderColor,
      bgColor,
      borderThickness,
      showXAxisPercentValues = chartConfig.showXAxisPercentValues,
      labels = manager.getGraphicalElement('commonLabels') || [],
      prevLabelLen = labels.length,
      i,
      j;

    smartLabel.setStyle(style);
    if (showXAxisPercentValues) {
      bgColor = pluck(style.backgroundColor, '#ffffff');
      borderColor = pluck(style.borderColor === BLANKSTRING ? '#' + inCanvasStyle.inCancolor :
        style.borderColor, '#000000');
      borderThickness = pluck(style.borderThickness, 1);
      for (index = 0; index < length - 1; index++) {
        if (!sumValues[index]) {
          continue;
        }
        percentValue += stackPercentValues[index];
        formatedPercentValue = numberFormatter.percentValue(percentValue);
        xPos = xAxis.getPixel(stackConf[index].x) + stackConf[index].columnWidth / 2;
        yPos = canvasBottom;
        labelEleCheck = labels[index];
        if (sumValues[index].positive === sumValues[index].negative) {
          formatedPercentValue = '';
          if (labelEleCheck) {
            labelEleCheck.hide();
          }
          continue;
        }
        attr = {
          text: formatedPercentValue,
          fill: style.color,
          'text-bound': [bgColor, borderColor,
            borderThickness, style.borderPadding,
            style.borderRadius, style.borderDash
          ],
          'line-height': style.lineHeight,
          visibility: visibleStr
        };

        bBoxObj = smartLabel.getOriSize(formatedPercentValue);

        yPos = yPos - bBoxObj.height / 2 - (borderThickness);
        attr.x = xPos;
        attr.y = yPos;
        labelEleCheck && labelEleCheck.show();
        labelEle = animationManager.setAnimation({
          el: labelEleCheck || 'text',
          container: commonLabelContainer,
          attr: attr,
          label: 'text',
          component: manager
        });
        if (!labelEleCheck) {
          manager.addGraphicalElement('commonLabels', labelEle, true);
        }
      }

      for (let i = index; i < prevLabelLen; i++) {
        labels[i].hide();
      }
    }
    for (i = 0; i < datasets.length; i++) {
      dataset = datasets[i];
      data = dataset.components.data;
      jsonData = dataset.config.JSONData;
      for (j = 0; j < data.length; j++) {
        data[j].config.finalTooltext = parseTooltext(data[j].config.finalTooltext, [111],
          {xAxisPercentValue: stackPercentValues[j] && (stackPercentValues[j].toPrecision(4) + '%')},
          data, chartAttr, jsonData);
      }
    }
  }

  /**
   * Helper function for determining the xPos of sumLabel
   * @param {number} index The index of the sumLabel
   * @return {number} x-position
   */
  _getXpos (index) {
    var manager = this,
      xAxis = manager.getFromEnv('xAxis');
    return xAxis.getPixel(manager.config.stackConf[index].x);
  }

  /**
   * Function to set column width and position of all the stacks
   */
  _setStackDimensions () {
    var manager = this,
      config = manager.config,
      k,
      stackSumValue = config.stackValues,
      categories = manager.getFromEnv('categories')[0].category,
      catObj,
      setUserWidth,
      len,
      sum = 0,
      positionStackConfig,
      numberFormatter = manager.getFromEnv('number-formatter'),
      percentValue,
      stackPercentValues = manager.getStackSumPercent(),
      canvasWidth = manager.getFromEnv('canvasConfig').canvasWidth,
      stackConf = config.stackConf || (config.stackConf = []);
    for (k = 0; k < categories.length; k++) {
      catObj = categories[k];
      if (catObj.widthpercent) {
        sum += numberFormatter.getCleanValue(catObj.widthpercent);
      }
    }
    if (sum === 100) {
      setUserWidth = config.setUserWidth = 1;
    }
    for (k = 0, len = stackSumValue.length; k < len; k++) {
      catObj = categories[k];
      if (!(positionStackConfig = stackConf[k])) {
        positionStackConfig = stackConf[k] = {};
      }
      if (setUserWidth) {
        percentValue = numberFormatter.getCleanValue(catObj.widthpercent) / 100;
      } else {
        percentValue = stackPercentValues[k] / 100;
      }
      positionStackConfig.columnWidth = percentValue * canvasWidth;
    }
  }
}

export default MarimekkoStackgroup;
